import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";

import userService from "../../app/services/user.service";

import Card from "../../UI/Card/Card";
import Graybg from "../../UI/Graybg";
import Loader from "../../UI/loader/loader";
import SecBTN from "../../UI/SecBTN";
import Toast from "../../UI/Toast/Toast";
import Select from "react-select";
import classes from "./facultyPaperCorrection.module.css";

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 34,
    height: 34,
    fontSize: 13,
    borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
    boxShadow: state.isFocused ? "0 0 0 0.15rem rgba(13,110,253,.2)" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#86b7fe" : "#adb5bd",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    height: 34,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: 13,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 34,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 6px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "0 4px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 13,
    color: "#9aa0a6",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 13,
  }),
  option: (base) => ({
    ...base,
    fontSize: 13,
    padding: "6px 10px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: 13,
    zIndex: 5,
  }),
};

const FacultyPaperCorrection = () => {
  const [loading, setLoading] = useState(false);

  const [paperList, setPaperList] = useState([]);
  const [allFacultyList, setAllFacultyList] = useState([]);

  const [selectedPaper, setSelectedPaper] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedFaculty, setSelectedFaculty] = useState("");
  const [selectedQuestionCount, setSelectedQuestionCount] = useState("");
  const [correctionRows, setCorrectionRows] = useState([]);

  const paperOptions = paperList.map((item) => ({
    value: item.paper_id,
    label: item.paper_name + "(" + item.paper_id + ")",
  }));

  const selectedPaperData = paperList.find(
    (item) => item.paper_id === selectedPaper
  );

  const subjectOptions = (() => {
    if (!selectedPaperData?.subjects) return [];

    try {
      const parsedSubjects = JSON.parse(selectedPaperData.subjects);
      const uniqueSubjects = [];
      const seenSubjectIds = new Set();

      parsedSubjects.forEach((item) => {
        if (!seenSubjectIds.has(item.sub_id)) {
          seenSubjectIds.add(item.sub_id);
          uniqueSubjects.push({
            value: item.sub_id,
            label: item.sub_name,
          });
        }
      });

      return uniqueSubjects;
    } catch (error) {
      console.log("Invalid subjects format for selected paper:", error);
      return [];
    }
  })();

  const totalQuestions =
    Number(selectedPaperData?.total_qus || selectedPaperData?.total_ques) || 0;

  const questionCountOptions = Array.from(
    { length: totalQuestions },
    (_, index) => ({
      value: index + 1,
      label: String(index + 1),
    })
  );

  const facultyOptions = allFacultyList.map((item) => ({
    value: item.user_id,
    label: item.user_name,
  }));

  const correctionTypeOptions = [
    { value: "1", label: "Answer Correction" },
    { value: "2", label: "Question Correction" },
    { value: "3", label: "Bonus" },
  ];

  const correctionReasonMap = {
    "1": [
      { value: "1", label: "Faculty Paper Not Checked Properly" },
      { value: "2", label: "SMD Operator Mistake" },
    ],

    "2": [
      { value: "1", label: "Language Correction" },
      { value: "2", label: "SMD Operator Mistake" },
      { value: "3", label: "Faculty Paper Not Checked Properly" },
    ],

    "3": [
      { value: "1", label: "Out of Syllabus" },
      { value: "2", label: "No Correct Option" },
      { value: "3", label: "Data Wrong" },
      { value: "4", label: "Figure Not Found" },
      { value: "5", label: "Faculty Paper Not Checked Properly" },
      { value: "6", label: "SMD Operator Mistake" },
    ],
  };

  const createEmptyRows = (count) =>
    Array.from({ length: count }, () => ({
      question_no: "",
      correction_type_id: "",
      correction_reason_type_id: "",
      old_answer: "",
      new_answer: "",
    }));

  const FacultyList = (sub_id) => {
    const payload = {
      sub_id: sub_id,
      paper_id: selectedPaperData.paper_id,
    }

    userService
      .getFacultyList(payload)
      .then((data) => {
        console.log("faculty list", data.data.data[0]);
        const datas = data.data.data;
        setAllFacultyList(datas);

      })
      .catch((err) => {
        console.log(err);
      });

  }

  useEffect(() => {
    setLoading(true);

    userService
      .getPaperList()
      .then((res) => {
        console.log("paper list", res.data);
        setPaperList(res.data || []);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unable to load papers.");
      })
      .finally(() => {
        setLoading(false);
      });


  }, []);

  const handleQuestionCountChange = (selected) => {
    const count = selected?.value || "";
    setSelectedQuestionCount(count);

    if (!count) {
      setCorrectionRows([]);
      return;
    }

    setCorrectionRows(createEmptyRows(count));
  };

  const updateCorrectionRow = (index, field, value) => {
    setCorrectionRows((prev) =>
      prev.map((row, rowIndex) =>
        rowIndex === index
          ? {
            ...row,
            [field]: value,
          }
          : row
      )
    );
  };

  const deleteCorrectionRow = (index) => {
    setCorrectionRows((prev) => {
      const updatedRows = prev.filter((_, rowIndex) => rowIndex !== index);
      setSelectedQuestionCount(updatedRows.length || "");
      return updatedRows;
    });
  };

  const resetForm = () => {
    setSelectedPaper("");
    setSelectedSubject("");
    setSelectedFaculty("");
    setSelectedQuestionCount("");
    setCorrectionRows([]);
  };

  const searchHandler = () => {
    if (!selectedPaper) {
      toast.error("Please select a paper.");
      return;
    }

    if (!selectedSubject) {
      toast.error("Please select a subject.");
      return;
    }

    if (!selectedFaculty) {
      toast.error("Please select a faculty.");
      return;
    }

    if (correctionRows.length === 0) {
      toast.error("Please add at least one question correction.");
      return;
    }

    const incompleteRow = correctionRows.find(
      (row) =>
        !row.question_no ||
        !row.correction_type_id ||
        !row.correction_reason_type_id
    );

    if (incompleteRow) {
      toast.error("Please fill all question correction rows.");
      return;
    }

    const body = {
      paper_id: selectedPaper,
      sub_id: selectedSubject,
      created_by: selectedFaculty,
      total_correction_no: selectedQuestionCount,
      correction_data: correctionRows.map((row) => ({
        q_no: row.question_no,
        correction_type_id: row.correction_type_id,
        correction_reason_type_id: row.correction_reason_type_id,
        old_correction: row.old_answer || "",
        new_correction: row.new_answer || "",
      })),
    };

    setLoading(true);

    userService
      .PaperCorrectionSubmit(body)
      .then((data) => {
        console.log("paper correction submit", data);
        toast.success("Paper correction submitted successfully.");
        resetForm();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unable to submit paper correction.");
      })
      .finally(() => {
        setLoading(false);
      });
  };



  return (
    <div className="section">
      {loading && <Loader />}
      <Toast />

      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Faculty Paper Correction</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Paper Correction</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Graybg>
        <Card className={`mb-4 ${classes.filterCard}`}>
          <Row className="g-2">
            <Col md={6}>
              <Form.Label className={classes.compactLabel}>
                Select Paper
              </Form.Label>
              <Select
                options={paperOptions}
                styles={selectStyles}
                value={
                  paperOptions.find((item) => item.value === selectedPaper) ||
                  null
                }
                onChange={(selected) => {
                  setSelectedPaper(selected?.value || "");
                  setSelectedSubject("");
                  setSelectedQuestionCount("");
                  setCorrectionRows([]);
                }}
                placeholder="Select Paper"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={6}>
              <Form.Label className={classes.compactLabel}>Subject</Form.Label>
              <Select
                options={subjectOptions}
                styles={selectStyles}
                value={
                  subjectOptions.find(
                    (item) => item.value === selectedSubject
                  ) || null
                }
                onChange={(selected) => {
                  setSelectedSubject(selected?.value || "");
                  FacultyList(selected?.value);
                }}
                placeholder="Select Subject"
                isSearchable
                isClearable
                isDisabled={!selectedPaper}
              />
            </Col>

            <Col md={6}>
              <Form.Label className={classes.compactLabel}>
                Faculty Name
              </Form.Label>
              <Select
                options={facultyOptions}
                styles={selectStyles}
                value={
                  facultyOptions.find(
                    (item) => item.value === selectedFaculty
                  ) || null
                }
                onChange={(selected) =>
                  setSelectedFaculty(selected?.value || "")
                }
                placeholder="Select Faculty"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={6}>
              <Form.Label className={classes.compactLabel}>
                No. of Questions
              </Form.Label>
              <Select
                options={questionCountOptions}
                styles={selectStyles}
                value={
                  questionCountOptions.find(
                    (item) => item.value === selectedQuestionCount
                  ) || null
                }
                onChange={handleQuestionCountChange}
                placeholder={
                  selectedPaper
                    ? "Select Number of Questions"
                    : "Select paper first"
                }
                isSearchable
                isClearable
                isDisabled={!selectedPaper || totalQuestions <= 0}
              />
            </Col>
          </Row>

          {correctionRows.length > 0 && (
            <>
              <div className={classes.sectionHeader}>
                Question Corrections ({correctionRows.length})
              </div>

              {correctionRows.map((row, index) => {
                const reasonOptions =
                  correctionReasonMap[row.correction_type_id] || [];

                return (
                  <div
                    key={`correction-row-${index}`}
                    className={classes.rowCard}
                  >

                    <Row className="g-2 align-items-end">
                      <Col md={2}>
                        <Form.Label className={classes.compactLabel}>
                          Question Number
                        </Form.Label>
                        <Select
                          options={questionCountOptions}
                          styles={selectStyles}
                          value={
                            questionCountOptions.find(
                              (item) => item.value === row.question_no
                            ) || null
                          }
                          onChange={(selected) =>
                            updateCorrectionRow(
                              index,
                              "question_no",
                              selected?.value || ""
                            )
                          }
                          placeholder="Q. No"
                          isSearchable
                          isClearable
                        />
                      </Col>

                      <Col md={2}>
                        <Form.Label className={classes.compactLabel}>
                          Paper Correction
                        </Form.Label>
                        <Select
                          options={correctionTypeOptions}
                          styles={selectStyles}
                          value={
                            correctionTypeOptions.find(
                              (item) => item.value === row.correction_type_id
                            ) || null
                          }
                          onChange={(selected) =>
                            updateCorrectionRow(
                              index,
                              "correction_type_id",
                              selected?.value || ""
                            )
                          }
                          placeholder="Correction Type"
                          isSearchable
                          isClearable
                        />
                      </Col>

                      <Col md={3}>
                        <Form.Label className={classes.compactLabel}>
                          Reason of Correction
                        </Form.Label>

                        <Select
                          options={correctionReasonMap[row.correction_type_id]}
                          styles={selectStyles}
                          value={
                            correctionReasonMap[row.correction_type_id]?.find(
                              (item) => item.value === row.correction_reason_type_id
                            ) || null
                          }
                          onChange={(selected) =>
                            updateCorrectionRow(
                              index,
                              "correction_reason_type_id",
                              selected?.value || ""
                            )
                          }
                          placeholder="Select Reason"
                          isSearchable
                          isClearable
                          isDisabled={!row.correction_type_id}
                        />
                      </Col>
                      {row.correction_type_id === "1" && (
                        <>
                          <Col md={2}>
                            <Form.Label className={classes.compactLabel}>
                              Old Answer
                            </Form.Label>
                            <Form.Control
                              type="text"
                              style={{height:'34px',border:''}}
                              placeholder="Enter Old Answer"
                              value={row.old_answer}
                              onChange={(e) =>
                                updateCorrectionRow(index, "old_answer", e.target.value)
                              }
                            />
                          </Col>

                          <Col md={2}>
                            <Form.Label className={classes.compactLabel}>
                              New Answer
                            </Form.Label>
                            <Form.Control
                              type="text"
                              style={{height:'34px',border:''}}
                              placeholder="Enter New Answer"
                              value={row.new_answer}
                              onChange={(e) =>
                                updateCorrectionRow(index, "new_answer", e.target.value)
                              }
                            />
                          </Col>
                        </>
                      )}

                      <Col md={1} className="d-flex justify-content-center">
                        <button
                          type="button"
                          className={classes.deleteBtn}
                          title="Delete row"
                          onClick={() => deleteCorrectionRow(index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </Col>
                    </Row>

                  </div>
                )
              })}
            </>
          )}

          <div className={`d-flex justify-content-center ${classes.submitWrap}`}>
            <SecBTN className="sec-btn1 px-4" onClick={searchHandler}>
              Submit
            </SecBTN>
          </div>
        </Card>
      </Graybg>
    </div>
  );
};

export default FacultyPaperCorrection;
